import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="bg-mist py-16 sm:py-20" aria-labelledby="guarantee-title" data-id="element-119" data-mp="4vry1r9ge1np">
      <div className="mx-auto max-w-2xl px-4 text-center" data-id="element-120" data-mp="9tl66pubh5qm">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.42
      }} className="rounded-3xl border border-line bg-white p-8 shadow-card sm:p-12" data-id="element-121" data-mp="et66p4p4xm5g">
          <span className="inline-flex rounded-full border border-aqua/35 bg-aquaSoft p-4 text-teal" data-id="element-122" data-mp="nrrkynnkqf0f">
            <ShieldCheckIcon className="h-10 w-10" data-id="element-123" data-mp="xjxmanzpu8sa" />
          </span>
          <h2 id="guarantee-title" className="mt-6 text-3xl font-extrabold text-ink" data-id="element-124" data-mp="xj5qbc27i91h">Garantía de 7 días, sin preguntas</h2>
          <p className="mt-4 leading-relaxed text-muted" data-id="element-125" data-mp="12h79dwzmu8cy">
            Abrís los tomos. Los usás. Si en 7 días no es lo que esperabas, solicitás tu devolución.
          </p>
          <p className="mt-6 rounded-xl border border-aqua/35 bg-aquaSoft px-5 py-4 text-lg font-extrabold text-teal" data-id="element-126" data-mp="25ti1a68kc0to">
            Devolución del 100% sin formularios, sin drama.
          </p>
          <p className="mt-5 text-xs font-bold uppercase tracking-[.14em] text-muted" data-id="element-127" data-mp="1vu9d5u0dpgf8">Tasa de devoluciones: menos del 1%</p>
        </motion.div>
      </div>
    </section>;
}